import { useState } from "react";
import { StaffDashboardOrgPreviewFragment, useOrgOffsetConnectionQuery } from "../../../../types";
import { useOffsetPagination } from "../../../../utils/pagination";
import { CreateOrgDialog } from "../../../../views/Staff/Orgs/CreateDialog";
import EditDialog from "../../../../views/Staff/Orgs/EditDialog";
import { OrgsTable } from "../../../../views/Staff/Orgs/Table";

export const OrgsPage = () => {
  const paginationHooks = useOffsetPagination();
  const { limit, offset, query, resetOffset } = paginationHooks;
  const [orgFilter, setOrgFilter] = useState<"all" | "active" | "inactive">("active");
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState<StaffDashboardOrgPreviewFragment | null>(null);

  const filter = orgFilter === "all" ? null : { isActive: orgFilter === "active" };

  const { data, loading, refetch } = useOrgOffsetConnectionQuery({
    variables: {
      input: { limit, offset },
      query,
      filter,
    },
    fetchPolicy: "network-only",
  });

  const handleOrgFilterChange = (value: "all" | "active" | "inactive") => {
    setOrgFilter(value);
    resetOffset();
  };

  return (
    <>
      <OrgsTable
        offsetConnectionData={data}
        loading={loading}
        paginationHooks={paginationHooks}
        orgFilter={orgFilter}
        onOrgFilterChange={handleOrgFilterChange}
        onEditOrg={setShowEdit}
        onCreateOrg={() => setShowCreate(true)}
        onRefreshSyncStatus={refetch}
      />
      {showCreate && (
        <CreateOrgDialog open={showCreate} onClose={() => setShowCreate(false)} onCreated={() => refetch()} />
      )}
      {!!showEdit && (
        <EditDialog org={showEdit} open={showEdit !== null} onClose={() => setShowEdit(null)} onEdit={() => refetch()} />
      )}
    </>
  );
};
